import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/** Legacy ClickUp feedback form (pre-Quackback). */
export const CLICKUP_FEEDBACK_FORM_URL =
  'https://forms.clickup.com/9012217812/f/8cjq1ym-988332/0946RYE9OA6PFCYQOX'

interface ClickUpFeedbackFormModalProps {
  open: boolean
  onClose: () => void
}

export function ClickUpFeedbackFormModal({
  open,
  onClose,
}: ClickUpFeedbackFormModalProps) {
  const { t } = useTranslation(['dashboard', 'common'])

  useEffect(() => {
    if (!open) return
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [open, onClose])

  if (!open) return null

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-stretch sm:items-center justify-center sm:p-6 bg-black/60"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="w-full h-full sm:h-[min(920px,95vh)] sm:max-w-4xl bg-[#212121] border-0 sm:border border-[#333333] sm:rounded-xl overflow-hidden flex flex-col shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={t('dashboard:sidebar.feedback.ariaLabel')}
      >
        <div className="flex items-center justify-between gap-2 px-4 py-3 border-b border-[#333333] flex-shrink-0">
          <h2 className="text-base font-semibold text-white truncate font-switzer">
            {t('dashboard:sidebar.feedback.ariaLabel')}
          </h2>
          <button
            type="button"
            onClick={onClose}
            className="flex-shrink-0 rounded p-1.5 text-gray-400 hover:text-white hover:bg-[#333333] transition-colors"
            aria-label={t('common:close')}
          >
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 min-h-0">
          <iframe
            className="clickup-embed clickup-dynamic-height w-full h-full min-h-[calc(100dvh-3.5rem)] sm:min-h-[calc(95vh-3.5rem)]"
            src={CLICKUP_FEEDBACK_FORM_URL}
            style={{ background: 'transparent', border: 'none' }}
            title={t('dashboard:sidebar.feedback.ariaLabel')}
          />
        </div>
      </div>
    </div>,
    document.body,
  )
}
